
export const monthInitials = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]
export  const utilities =  {
    validateEmail(email) {
      console.log("function is invoked")
      console.log(email)
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    // validate working email
workingEmail(email){
  const domain = email.substring(email.lastIndexOf("@")).toLowerCase()
  if (domain == "@gmail.com" || domain == "@yahoo.com" || domain == "@outlook.com" || domain == "@hotmail.com"){
    return false
  }else{
    return true
  }
},
    // validatePhone(phoneNumber) {
    //   phoneNumber = phoneNumber
    //     .replace("-", "")
    //     .replace("(", "")
    //     .replace(")", "")
    //     .replace(/\s/g, "");
    //   if (phoneNumber.indexOf("+") == 0) {
    //     if (phoneNumber.length < 8) {
    //       return false;
    //     }
    //     if (phoneNumber.length > 19) {
    //       return false;
    //     }
    //   }
    //   if (phoneNumber.length < 7) {
    //     return false;
    //   }
    //   if (phoneNumber.length > 18) {
    //     return false;
    //   }
    //   var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,30}$/;
    //   return regex.test(String(phoneNumber).toLocaleLowerCase());
    // },
    // validateUrl(url) {
    //     var regex =
    //       /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    //     return regex.test(String(url).toLocaleLowerCase());
    //   },
    //   validateYoutubeUrl(url) {
    //     var regex =
    //       /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
    //     return regex.test(String(url).toLocaleLowerCase());
    //   },
    //   getLoggedInUser(eventAlias) {
    //     var userInfoString = localStorage.getItem(
    //       Constants.API_TOKEN + eventAlias + "user_info"
    //     );
    //     return JSON.parse(userInfoString);
    //   },
    //   validPassFormat(pass) {
    //     return pass.length > 7;
    //   },
    //   validName(name) {
    //     var regex = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
    //     return regex.test(name);
    //   },
    //   convertUTCDateToLocalDate(date) {
    //     var newDate = new Date(
    //       date.getTime() + date.getTimezoneOffset() * 60 * 1000
    //     );
    //     var ua = navigator.userAgent.toLowerCase();
    //     var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    //     var offset = date.getTimezoneOffset() / 60;
    //     var hours = date.getHours();
    //     if (isSafari) {
    //       offset = 0;
    //     }
    //     newDate.setHours(hours - offset);
    
    //     return newDate;
    //   },
    //   getDateString(date) {
    //     var _date = new Date(date);
    //     return (
    //       _date.getDate() +
    //       " " +
    //       monthNames[_date.getMonth()] +
    //       " " +
    //       _date.getFullYear()
    //     );
    //   },
      loggedUser(){
       return JSON.parse(localStorage.getItem("loggedUser"))
      },
      namesValidation(name){
        let upperCaseLetter = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
              let keyCode = name.which || name.keyCode
              if(upperCaseLetter.includes(name.key) ){
                // name.preventDefault();
                return false
              }
              else{
                return true
              }

      },
      convertUTCDateToLocalDate(date) {
        var newDate = new Date(
          date.getTime() + date.getTimezoneOffset() * 60 * 1000
        );
        var ua = navigator.userAgent.toLowerCase();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        if (isSafari) {
          offset = 0;
        }
        newDate.setHours(hours - offset);
    
        // return newDate;
        var numberofdays = Math.floor((new Date().getTime() - new Date(newDate).getTime())/(1000*60*60*24))
        if(numberofdays > 1){
          return `${numberofdays} days ago`
        }
        else if (numberofdays <= 1){
          return `Today at ${newDate.getHours()}:${newDate.getMinutes()}`
        }
        else if (numberofdays >= 30){
          return `${Math.floor(numberofdays/30)} months ago`
        }
        else if (numberofdays >= 356){
          return `${Math.trunc(numberofdays/365)} years ago`
        }
      },    
      getDaysHoursFromMiliseconds(ms){
        const days = Math.floor(ms / (24*60*60*1000));
        const daysms = ms % (24*60*60*1000);
        const hours = Math.floor(daysms / (60*60*1000));
        const hoursms = ms % (60*60*1000);
        const minutes = Math.floor(hoursms / (60*1000));
        const minutesms = ms % (60*1000);
        const sec = Math.floor(minutesms / 1000);

        return {
          days,hours,minutes,sec
        }
      },
      getParameterByName(name, url = window.location.href) {
        url = new URL(url)
        const searchParams = new URLSearchParams(url.search);
        return searchParams.get(name)
      }
      ,
      csvToArray(str, delimiter = ","){
        const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
      const rows = str.slice(str.indexOf("\n") + 1).split("\n");
      const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
          object[header] = values[index];
          return object;
        }, {});
        return el;
      });
      return arr;
    
      }
}